import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { ConditionRegistryStage } from './ConditionRegistryStage';
import { ConditionRegistryApp } from './ConditionRegistryApp';
import { ConditionRegistryImage } from './ConditionRegistryImage';
import { ConditionRegistryText } from './ConditionRegistryText';
export class ConditionRegistryActorType extends ConditionRegistryCategory {
    label = 'Akteurtypen';
    c_s = new ConditionRegistryStage(this);
    c_a = new ConditionRegistryApp(this);
    c_i = new ConditionRegistryImage(this);
    c_t = new ConditionRegistryText(this);
}
